// Danh sách key sử dụng ở IndexedDb
const idbKeys = Object.freeze({
  CacheTime: 'CacheTime',
  Grade: 'Grade',
  Subject: 'Subject',
  UserOption: 'UserOption',
  SchoolYearData: 'SchoolYearData',
  SchoolYear: 'SchoolYear',
  TeacherRankingConfig: 'TeacherRankingConfig'
})

export default idbKeys
